"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";

/**
 * The revision a one-click command goes out on. While an attempt's answer is
 * unconfirmed, sending the same intent again keeps the revision it was first
 * sent on — even when the page shows a newer one since — so useCommandAttempt
 * repeats the same operation and the server can replay it. A definite answer,
 * or another intent, decides against the revision shown.
 */
export function useUnconfirmedRevision() {
  const $ = _c(4);
  const pending = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (intent, shown) => {
      const attempt = pending.current;
      return attempt?.intent === JSON.stringify(intent) ? attempt.revision : shown;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const revisionFor = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (intent_0, revision, unconfirmed) => {
      pending.current = unconfirmed ? {
        intent: JSON.stringify(intent_0),
        revision
      } : null;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const answered = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      pending.current = null;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const forget = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      revisionFor,
      answered,
      forget
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}